import styled from "@emotion/styled";
import LabelWithInput from "@components/input/LabelWithInput";
import NumberInput from "@components/input/NumberInput";
import { useFormContext } from "react-hook-form";

const FeeWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
  fontSize: "1.6rem",
}));

const Suffix = styled.span(({ theme }) => ({
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.bold,
  lineHeight: "2rem",
  color: theme.color.black,
}));

const DescriptionBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.8rem",
  fontSize: "1.4rem",
  lineHeight: "1.6rem",
  color: theme.color.gray,

  ".tip": {
    color: theme.color.orange,
  },
}));

const DeliveryFeePolicy = () => {
  const { watch } = useFormContext();

  return (
    <LabelWithInput
      label="배송비 설정"
      required
      gap="2rem"
      tooltip
      tooltipContent={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}>
          <span>
            {
              "* 도서산간 지역의 기준은 판매자가 이용하는 택배사마다 상이할 수 있습니다. 추가 요금 발생 지역 고객님의 경우, 상품 수령시 택배사로부터 지불요청이 있을 수 있습니다."
            }
          </span>

          <span>
            {
              "* 해외 배송은 무게 측정 후 배송비를 별도로 구매자에게 청구하시기 바랍니다."
            }
          </span>
        </div>
      }>
      <FeeWrapper>
        <label>{"기본 배송비"}</label>

        <NumberInput
          name={`shipping_fee`}
          type="number"
          mode="numeric"
          dir="rtl"
          max={11}
          value={watch(`shipping_fee`)}
          placeholder="1,000">
          <Suffix> {"원"}</Suffix>
        </NumberInput>
      </FeeWrapper>

      <FeeWrapper>
        <label>{"조건부 무료배송"}</label>

        <DescriptionBox>
          <span>ex) {"50,000원 이상 구매 시 무료배송이면 50,000 입력"}</span>
          <span className="tip">
            ※ {"무료배송을 사용하지 않으실 경우, 공란으로 비워놓아 주세요."}
          </span>
          <span className="tip">
            ※{" "}
            {"묶음배송 주문을 고려해 무료 배송비 기준을 설정하시길 권장합니다."}
          </span>
        </DescriptionBox>

        <NumberInput
          name={`free_shipping_fee`}
          type="number"
          mode="numeric"
          dir="rtl"
          max={11}
          value={watch(`free_shipping_fee`)}
          placeholder="1,000">
          <Suffix> {"원"}</Suffix>
        </NumberInput>
      </FeeWrapper>
    </LabelWithInput>
  );
};

export default DeliveryFeePolicy;
